import { UserInfo } from "@features/auth/useAuth";
import { Avatar, AvatarFallback, AvatarImage } from "@shadcn/ui/avatar";
import { ComponentProps } from "react";

type UserAvatarProps = ComponentProps<typeof Avatar> & {
	user: UserInfo;
};

export const UserAvatar = (props: UserAvatarProps) => {
	const { user, ...avatarProps } = props;

	const initials =
		user.name
			?.split(" ")
			.map((name) => name[0])
			.join("") || user.email.charAt(0);
	return (
		<Avatar {...avatarProps}>
			<AvatarImage src={user.avatar} alt={user.name} />
			<AvatarFallback>{initials}</AvatarFallback>
		</Avatar>
	);
};
